'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var buffer = require('buffer');
var isSvg = require('is-svg');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var isSvg__default = /*#__PURE__*/_interopDefaultLegacy(isSvg);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var readAsText = function (svg) {
    return new Promise(function (resolve) {
        if (!isFile(svg)) {
            resolve(svg.toString('utf-8'));
        }
        else {
            var fileReader_1 = new FileReader();
            fileReader_1.onload = function () {
                resolve(fileReader_1.result);
            };
            fileReader_1.readAsText(svg);
        }
    });
};
var isFile = function (obj) {
    return obj.size !== undefined;
};
var sanitizeSVG = function (svg) { return __awaiter(void 0, void 0, void 0, function () {
    var svgText, div, svgEl, attributes, hasScriptAttr, scripts;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!svg) {
                    throw new Error('Not an svg');
                }
                svgText = '';
                if (!(buffer.Buffer.isBuffer(svg) || svg instanceof File)) return [3 /*break*/, 2];
                return [4 /*yield*/, readAsText(svg)];
            case 1:
                svgText = (_a.sent());
                return [3 /*break*/, 3];
            case 2:
                svgText = svg;
                _a.label = 3;
            case 3:
                if (!isSvg__default["default"](svgText)) {
                    throw new Error('Not an svg');
                }
                div = document.createElement('div');
                div.innerHTML = svgText;
                svgEl = div.firstElementChild;
                attributes = Array.from(svgEl.attributes).map(function (_a) {
                    var name = _a.name;
                    return name;
                });
                hasScriptAttr = !!attributes.find(function (attr) { return attr.startsWith('on'); });
                scripts = svgEl.getElementsByTagName('script');
                return [2 /*return*/, scripts.length === 0 && !hasScriptAttr ? svg : null];
        }
    });
}); };

exports.sanitizeSVG = sanitizeSVG;
//# sourceMappingURL=index.js.map
